import React from 'react';
import ReactPlayer from 'react-player';

const VideoPlayer = ({ video, track }) => {
    return (
        <ReactPlayer
            url={video}
            controls
            width='auto'
            height='auto'
            config={{
                hlsOptions: {
                    autoStartLoad: true,
                },
                file: {
                    tracks: [
                        {
                            kind: 'subtitles',
                            src: track,
                            srcLang: 'en',
                            default: true,
                        },
                    ],
                },
            }}
        />
    );
};

export default VideoPlayer;
